'use client'
import { MultiSelectFormListStringFieldOneLineUiTest } from '@repo/ui'
import { useRouter, useSearchParams, usePathname } from 'next/navigation'

export default function TechnologiesFilterClient({ options, value }: { options: string[]; value: string[] }) {
  const router = useRouter()
  const search = useSearchParams()
  const pathname = usePathname()

  const setValue = (next: string[]) => {
    const p = new URLSearchParams(search.toString())
    next.length ? p.set('Technologies', next.join(',')) : p.delete('Technologies')
    router.push(`${pathname}?${p}`, { scroll: false })
  }

  return (
    <MultiSelectFormListStringFieldOneLineUiTest
      options={options}
      defaultValue={value}
      onValueChange={setValue}
      placeholder="Technology"
      className="max-w-[280px]"
      popoverContentClassName="min-w-[348px]"
    />
  )
}
